module.exports = __webpack_public_path__ + "float_bc.85d9700f.png";